module.exports = __webpack_public_path__ + "static/media/cover-fallback.5cda2283.png";